import React from 'react';
import InternalLink from '../../input/InternalLink';

export type GuestLoginPromptProps = {
  showLoginForm: () => void;
};

const GuestLoginPrompt: React.FC<GuestLoginPromptProps> = ({
  showLoginForm,
}: GuestLoginPromptProps) => {
  return (
    <div className="text-sm m-2">
      Already have an account?{' '}
      <InternalLink onClick={showLoginForm}>Log in</InternalLink>
    </div>
  );
};

export default GuestLoginPrompt;
